import { render, staticRenderFns } from "./StorageSpaceFilter.vue?vue&type=template&id=0636be7c&"
import script from "./StorageSpaceFilter.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports